import { createIcon } from '@chakra-ui/react';

export const DisabledDot = createIcon({
  displayName: 'DisabledDot',
  viewBox: '0 0 12 12',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <circle cx="6" cy="6" r="5.25" fill="#EDEDED" stroke="#E0E0E0" strokeWidth="1.5" />
    </svg>,
  ],
});
